window.tinymce.PluginManager.add('zatap', function (editor) {
  const intl = editor.getParam('intl');
  const scope = 'ui.form.field.text_editor.zatap';

  const dataFields = [
    { text: 'Voucher Code', value: 'voucher_code' },
    { text: 'Voucher Code (legacy)', value: 'serial_number' },
  ];

  editor.ui.registry.addMenuButton('zatap', {
    text: intl.t(`${scope}.label`),
    tooltip: intl.t(`${scope}.tooltip`),
    fetch: (callback) => {
      const items = [
        {
          type: 'menuitem',
          text: intl.t(`${scope}.field`),
          onAction: () => {
            // Open the input dialog
            editor.windowManager.open({
              title: 'Data Field',
              body: {
                type: 'panel',
                items: [
                  {
                    type: 'selectbox',
                    name: 'field',
                    label: 'Select a data field',
                    items: dataFields,
                  },
                ],
              },
              buttons: [
                {
                  type: 'cancel',
                  text: 'Close',
                },
                {
                  type: 'submit',
                  text: 'Save',
                  primary: true,
                },
              ],
              onSubmit: (api) => {
                const data = api.getData();
                const { text, value } = dataFields.find(
                  (item) => item.value === data.field,
                );
                editor.insertContent(
                  `<zatapdatafield contenteditable="false" data-zatap-data-field="${value}" data-zatap-data-field-label="${text}">&nbsp;</zatapdatafield>`,
                );
                api.close();
              },
            });
          },
        },
        {
          type: 'menuitem',
          text: intl.t(`${scope}.custom_field`),
          onAction: () => {
            // Open the input dialog
            editor.windowManager.open({
              title: 'Custom Field',
              body: {
                type: 'panel',
                items: [
                  {
                    type: 'input',
                    name: 'field_name',
                    label: 'Enter your custom field name',
                  },
                ],
              },
              buttons: [
                {
                  type: 'cancel',
                  text: 'Close',
                },
                {
                  type: 'submit',
                  text: 'Save',
                  primary: true,
                },
              ],
              onSubmit: (api) => {
                const data = api.getData();
                editor.insertContent(
                  `<zatapdatafield contenteditable="false" data-zatap-data-field="${data.field_name}" data-zatap-data-field-label="Custom Field (${data.field_name})">&nbsp;</zatapdatafield>`,
                );
                api.close();
              },
            });
          },
        },
      ];

      callback(items);
    },
  });
});
